import React from 'react'
import { getTranslation } from '../models/Translation';
import { MenuItemStats } from '../models/Statistics';
import AlternatingTableRow from '../table/AlternatingTableRow';
import StandardTableCell from '../table/StandardTableCell';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Box, Typography } from '@mui/material';

const TrendCell: React.FC<{ likes: number; dislikes: number }> = ({ likes, dislikes }) => {
    const net = likes - dislikes;
    if (likes === 0 && dislikes === 0) return <span className="flex justify-end">-</span>;

    return (
        <Box display="flex" alignItems="center" justifyContent={"flex-end"} gap={0.5}>
            {net >= 0 ? (
                <ArrowUpwardIcon fontSize="small" color="success" />
            ) : (
                <ArrowDownwardIcon fontSize="small" color="error" />
            )}
            <Typography variant="body2">{net}</Typography>
        </Box>
    );
};

type Props = {
    itemStats: MenuItemStats;
    index: number;
}

const MenuStatisticTableRow = ({ itemStats, index }: Props) => {
    const translation = getTranslation(itemStats.translations);

    return (
        <AlternatingTableRow key={`rating-item-${itemStats.menuItemId}`} index={index}>
            <StandardTableCell>{translation.title}</StandardTableCell>
            <StandardTableCell align="right">{itemStats.likeCount}</StandardTableCell>
            <StandardTableCell align="right">{itemStats.dislikeCount}</StandardTableCell>
            <StandardTableCell>
                <TrendCell {...itemStats.trend7} />
            </StandardTableCell>
            <StandardTableCell>
                <TrendCell {...itemStats.trend30} />
            </StandardTableCell>
        </AlternatingTableRow>
    );
}

export default MenuStatisticTableRow